import React from 'react'
import Img1Sys from '../assets/img1Syn.svg'
import Img2Sys from '../assets/Img2Sys.svg'
import Img3Sys from '../assets/Img3Sys.svg'
import Img4Sys from '../assets/Img4Sys.svg'

const Synthese: React.FC<{
  mantantToSend?: number
  taux?: number
  com?: number
  mantantToRecu?: number
  text: string
  LabelMantantToSend: string
  labelTaux: string
  labelCom: string
  LabelMantantToRecu: string
  valuePays: any
}> = ({
  mantantToSend,
  taux,
  com,
  mantantToRecu,
  text,
  LabelMantantToSend,
  labelTaux,
  labelCom,
  LabelMantantToRecu,
  valuePays,
}) => {

  const calculerTotal = ()=>{
    const comToPay = Number(com) || 0
    const montant = Number(mantantToSend) || 0
    if (montant > 14 && montant <= 5000 ) {
      const total = (montant + comToPay).toFixed(3)
      return parseFloat(total)

    }
    return null
  }

  return (
    <div className="sm:hidden w-[380px] xl:w-[250px] max-h-max  z-50 bg-[#F1F1FF] font-roboto">
    <div  className='py-[28px] px-5'>
      <div className="text-[20px] font-semibold">Synthèse</div>


      <div className="flex items-center justify-between  mt-[25px]">
        <div className="flex items-center">
          <img src={Img1Sys}  />
          <div className="text-[#474747] text-[15px] font-bold pl-3">{LabelMantantToSend}</div>
        </div>
        <div className="text-[#474747] text-[15px] font-bold">
          {mantantToSend && mantantToSend <= 5000 ? mantantToSend : '-'}
        </div>
      </div>

      <div className="flex items-center justify-between mt-[25px]">
        <div className="flex items-center">
          <img src={Img2Sys}  />
          <div className="text-[#474747] text-[15px] font-normal pl-3">{labelTaux}</div>
        </div>
        <div className="text-[#474747] text-[15px] font-normal">{taux}</div>
      </div>

      <div className="flex items-center justify-between mt-[25px]">
        <div className="flex items-center">
          <img src={Img3Sys}  />
          <div className="text-[#474747] text-[15px] font-normal pl-3">{labelCom}</div>
        </div>
        <div className="text-[#474747] text-[15px] font-normal">
          {mantantToSend && mantantToSend <= 5000 && mantantToSend && mantantToSend >= 15 ? `+  ${com} €` : '-'}
        </div>
      </div>

      

      <div className="flex items-center justify-between mt-[25px]">
        <div className="flex items-center">
          <img src={Img4Sys} />
          <div className="text-[#474747] text-[15px] font-semibold pl-3">{LabelMantantToRecu}</div>
        </div>
        <div className="text-[#474747] text-[15px] font-semibold">
          {mantantToSend && mantantToSend <= 5000 && mantantToRecu ? mantantToRecu : '-'}{' '}
          {valuePays?.value}
        </div>
      </div>

      <div className="flex items-center justify-between mt-[25px] border-t border-[#E2E2FB] pt-2">
        <div className="flex items-center">
          <img src={Img1Sys} />
          <div className="text-[#735CFE] text-[15px] font-bold pl-3">{text}</div>
        </div>
        <div className="text-[#735CFE] text-[15px] font-bold">
          {calculerTotal() !== null ? `${calculerTotal()} €` : '-'}


         
        </div>
      </div>

    </div>
      <div className='bg-[#D1D1FF] h-[12px]'/>

    </div>
  )
}

export default Synthese
